import * as actions from './recipe/actions'
import * as mutations from './recipe/mutations'
import * as getters from './recipe/getters'

import { basicProps } from './recipe/properties'

const state = {
    filterText: '',
    list: [JSON.parse(JSON.stringify(basicProps))]
}

export default {
    state,
    actions,
    mutations,
    getters
}


// WEBPACK FOOTER //
// ./src/store/modules/recipe.js